import { Injectable, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PriceService } from '@df/ui/price/price.service';
import { Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TaxParamService {
    private subscriptions: Subscription = new Subscription();
    private activatedRoute = inject(ActivatedRoute);
    private priceService = inject(PriceService);
    private hasSetTaxParam = false;

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    setTaxBasedOnUrlParam(): void {
        this.subscriptions.add(
            this.activatedRoute.queryParamMap.subscribe(queryMap => {
                if (!this.hasSetTaxParam) {
                    const includeVat = queryMap.get('vat');
                    if (includeVat === '1' || includeVat === '0') {
                        this.priceService.showCatalogPricesInclTax = includeVat === '1';
                    }
                }
            })
        );
    }
}
